import axios from "axios";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import { describeImportRequestError } from "../articleImportErrors";
export async function postPartnerImportBatch(payload, signal) {
  try {
    const response = await axios.post(`${ApiLink.API_URL}PartnerImport/save-batch`, payload,
      { headers: authHeader(), timeout: 120000, signal });
    return response.data;
  } catch (error) { throw new Error(describeImportRequestError(error, "Ruajtja e partnerëve")); }
}

